import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios.get('https://solanthegroup.com/admin/api/blogs')
      .then(response => setBlogs(response.data))
      .catch(error => console.error('Error fetching blogs:', error));
  }, []);

  return (
    <div>
      {blogs.length > 0 &&
        <div className="tmp-blog-area tmp-section-gapBottom  my-5 py-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head">
                  <div className="section-sub-title center-title">
                    <img src="assets/images/services/section-custom-menubar.png" alt="Corporate_service" />
                    <span className="subtitle">LATEST BLOG</span>
                  </div>
                  <h2 className="title split-collab">Latest News &amp; Articles</h2>
                </div>
              </div>
            </div>
            <div className="row g-5">
              {blogs.map(blog => (
                <div key={blog.id} className="col-lg-4 col-md-6 col-sm-12 col1-2 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
                  <div className="single-blog">
                    <div className="blog-inner">
                      <div className="thumbnail">
                        <Link to={`/BlogDetails?id=${blog.id}`}>
                          <img src={`https://solanthegroup.com/admin/${blog.photo}`} alt={blog.title} />
                        </Link>
                        <div className="pmt-blog-meta">
                          <ul className="all-meta">
                            <li className="date"><span>{new Date(blog.created_at).getDate()}</span></li>
                            <li className="month"><span>{new Date(blog.created_at).toLocaleString('en-US', { month: 'short' }).toUpperCase()}</span></li>
                          </ul>
                        </div>
                      </div>
                      <div className="blog-content">
                        <div className="blog-body">
                          <Link to={`/BlogDetails?id=${blog.id}`} className="title-area">
                            <h4 className="title">{blog.title}</h4>
                          </Link>
                          <p className="description" dangerouslySetInnerHTML={{ __html: blog.description.split(" ").slice(0, 12).join(" ") }}></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    </div>
  );
}
